






























































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import store from "@/store";
import { imageUrl } from "@/utils/common";
import {base64DownloadFile, ExportExcel} from "@/utils/exportFile";
@Component({})
export default class shopDetail extends Vue {
  baseUrl = imageUrl;
  id: any = "";
  order: any = {};
  payList = [];
  payTotal = 0
  pay = {
    id: '',
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  finshList = [];
  finshTotal = 0
  finsh = {
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  cancelList = [];
  cancleTotal = 0
  cancel = {
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  refundList = [];
  refundTotal = 0
  refund = {
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  remarkList = [];
  currentFlowIndex = 0;
  btnLoading = false;
  drawer = false;
  form = {};
  RefundList = []; // 退款列表
  ReleaseList = []; // 解保列表
  LetterList = []; // 出函列表
  orderList = []; // 订单列表
  InvoiceList = []; // 发票列表
  InvoiceTotal = 0
  Invoice = {
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };
  ApprovalList = []; // 审批列表
  ContractList = []; // 合同列表
  letterDialog = false;
  letterForm = {};
  config = {};
  fileList: any = {};
  lookDialog = false;

  file: any = [];
  Attachments = [];
  audit = [];
  detail = {};
  lookType = "";
  base64 = "";
  dialogVisible = false;
  invoiceStatus = {
    0: "待申请",
    1: "申请中",
    2: "已申请",
    3: "已冲红",
  };
  dialogs = {
    examineDialog: false,
    orderDialog: false,
    bussnessDialog: false,
  };
  baseInfo = {};
  activeFlowIndex = 0;
  optionData = {};
  buttonList = [];
  TenantUserName = "";
  tenantUserId = "";
  InvoiceDialog = false;
  invoice = {
    bankAccount: "",
    bankName: "",
    companyAddress: "",
    companyPhone: "",
    email: "",
    invoiceTitle: "",
    orderId: "",
    taxNumber: "",
    invoiceType: "",
    userId: "",
  };
  loading = false;
  invoice_type = {};
  preRebuildDialog = false;
  logDialog = false;
  logList = [];
  logTotal = 0;
  listLoading = false;

  lookLogDialog = false;
  channelLogList = [];
  channelLoading = false;

  BCDialog = false;
  txzlVal = [];
  fjzlVal = [];

  fieldList = [];

  SupplementField = { props: { options: [] } };
  imgUrl = "";
  lookInfo = {};
  lookTitle = "";
  innerDrawer = false;
  activeName = 'zhifu'; // 存放默认展开的 key

  payForm: any = {};
  dataAuth = {};

  orderFile: any = [];

  refundDialog = false;
  refundForm: any = {};
  refundFile: any = {};

  cancleDialog = false;
  cancleForm: any = {};
  cancleFile: any = {};
  code = "";

  userId = JSON.parse(sessionStorage.getItem("vuex") as any).user.user.id;


  getPayList() {
    api.post('J27768', {...this.pay, id: this.id}).then(res => {
      this.payList = res.list
      this.payTotal = res.total
    })
  }

  getFinshList() {
    api.post('J27766', {...this.finsh, id: this.id}).then(res => {
      this.finshList = res.list
      this.finshTotal = res.total
    })
  }

  getInvoiceList() {
    api.post('J27767', {...this.finsh, id: this.id}).then(res => {
      this.InvoiceList = res.list
      this.InvoiceTotal = res.total
    })
  }
  getCancleList() {
    api.post('J27765', {...this.cancel, id: this.id}).then(res => {
      this.cancelList = res.list
      this.cancleTotal = res.total
    })
  }
    getRefundList() {
    api.post('J27769', {...this.refund, id: this.id}).then(res => {
      this.refundList = res.list
      this.cancleTotal = res.total
    })
  }


  handleClick(tab: any, event: any) {    
    let index = tab.index;

    if(index == 0) {
      this.getPayList()
    } else if(index == 1) {
      this.getFinshList()
    } else if(index == 2) {
      this.getInvoiceList()
    } else if(index == 3) {
      this.getCancleList()
    } else if(index == 4) {
      this.getRefundList()
    }
  }


  handleCloseCancle() {
    this.cancleDialog = false;
  }

  delCancle(key: any) {
    this.cancleFile = {};
  }

  sureCancle() {
    if (!this.cancleForm.cancelReason) {
      this.$message.warning("请选择取消原因");
      return;
    }
    if (!this.cancleForm.cancelNote) {
      this.$message.warning("请输入取消原因");
      return;
    }
    let obj = {
      orderId: this.id,
      ...this.cancleForm,
      cancleVoucher: this.cancleFile.image_url,
    };

    this.loading = true;
    api
      .post("J27752", obj)
      .then((res) => {
        this.$message.success("操作成功");
        this.fetchData();
        this.cancleDialog = false;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  handleCloseRefund() {
    this.refundDialog = false;
  }

  handleSuccessRefund(res: any, file: any) {}

  delRefund() {
    this.refundFile = {};
  }

  sureRefund() {
    if (!this.refundForm.refundReason) {
      this.$message.warning("请输入退款原因");
      return;
    }
    if (!this.refundForm.refundAmount) {
      this.$message.warning("请输入退款金额");
      return;
    }
    if (!this.refundFile.image_url) {
      this.$message.warning("请上传退款凭证");
      return;
    }
    if (!this.refundForm.refundNote) {
      this.$message.warning("请输入退款说明");
      return;
    }
    this.loading = true;
    api
      .post("J27755", {
        orderId: this.id,
        refundVoucher: this.refundFile.image_url,
        ...this.refundForm,
      })
      .then((res) => {
        this.$message.success("操作成功");
        this.fetchData();
        this.refundDialog = false;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  handleAvatarSuccessOrder(res: any, file: any) {
    if (res.data && res.code == 0) {
      let obj = {
        fileName: this.fileName,
        fileCode: res.data.fileCode,
        url: res.data.url,
      };
      this.orderFile = [...this.orderFile, obj];
    } else {
      this.$message.warning("上传失败，请重新上传");
    }
  }

  getError(res: any, file: any) {
    this.$message.error("文件上传失败，请重试");
  }

  handleExceed(files: any, fileList: any) {
    this.$message.warning(
      `当前限制选择 1个文件，本次已选择 ${fileList.length} 个文件`
    );
  }

  fileName = "";

  delOrder(key: any) {
    this.orderFile.splice(key, 1);
  }

  getAction() {
    // return uploadUrl;
  }
  handleAvatarSuccess(res: any, file: any) {
    if (res.errcode == 0) {
      let obj = {
        image_name: file.name,
        image_url: res.data,
      };
      this.refundFile = obj;
    } else {
      this.$message.error("上传失败");
    }
  }
  handleAvatarSuccessCancle(res: any, file: any) {
    if (res.errcode == 0) {
      let obj = {
        image_name: file.name,
        image_url: res.data,
      };
      this.cancleFile = obj;
    } else {
      this.$message.error("上传失败");
    }
  }
  beforeAvatarUpload(file: any) {
    // const isJPG = file.type === "image/jpeg" || file.type === "image/png";
    // const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isJPG) {
    //   this.$message.error("上传图片只能是 JPG/PNG 格式!");
    // }
    // if (!isLt2M) {
    //   this.$message.error("上传图片大小不能超过 2MB!");
    // }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let _that = this;
    return new Promise(function (resolve, reject) {
      // if (isJPG && isLt2M) {
        _that.loading = true
        api
          .post("J27501", {
            fileName: file.name,
            softLink: "",
          })
          .then((data) => {
            _that.dataAuth = data;
            resolve(true);
          })
          .catch(() => {
            reject(false);
          }).finally(() => {
            _that.loading = false
          });
      // } else {
      //   reject(false);
      // }
    });
  }

  del(key: any) {
    this.file.splice(key, 1);
  }

  type = ''
  toLook(type: any, row: any) {
    if(type == 3) {
    api.post("J27739", { id: row.id }).then((res) => {
      this.type = type
      this.lookInfo = res;
      this.innerDrawer = true;
    });
      return
    }
    this.type = type
    this.lookInfo = row;
    this.innerDrawer = true;
  }

  handleCloseLook() {
    this.innerDrawer = false;
  }

  cancleBCDialog() {
    this.BCDialog = false;
  }

  // 日志
  cancleLog() {
    this.logDialog = false;
  }
  cancleLogLook() {
    this.lookLogDialog = false;
  }

  logSearch = {
     objectId: "",
    objectType: "order_manage",
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 10, //每页数量
    },
  };
  logTable = [];
  toLog() {
    this.logSearch.objectId = this.id;
    api.post("J27756", { ...this.logSearch }).then((res) => {
      this.logDialog = true;
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  changeLog(page: any) {
    this.logSearch.pagination.page = page - 1;
    api.post("J27756", { ...this.logSearch }).then((res) => {
      // this.logDialog = true
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  row = {};
  logDetail = false;
  openDesc = false;
  handleCloseLogDialog() {
    this.logDialog = false;
  }
  toLogDetail(row: any) {
    this.logDetail = true;
    this.row = row;
  }
  CloseLogDetailDialog() {
    this.logDetail = false;
  }

  // 联系客户
  toKeHu() {
    const h = this.$createElement;

    this.$msgbox({
      title: "联系客户",
      message: h("div", [
        h(
          "p",
          "联系人：" + (this.order.userNickname ? this.order.userNickname : "-")
        ),
        h("p", "联系方式：" + (this.order.phone ? this.order.phone : "-")),
      ]),
      showCancelButton: false,
      confirmButtonText: "确定",
      beforeClose: (action, instance, done) => {
        done();
      },
    }).then((action) => {});
  }

  // 申请发票

  cancleApplyInvoice() {
    this.InvoiceDialog = false;
  }

  invoiceSubmit() {
    if (!this.invoice.invoiceType) {
      this.$message.warning("请选择发票类型");
      return;
    }
    if (!this.invoice.invoiceTitle) {
      this.$message.warning("请输入发票抬头");
      return;
    }
    if (!this.invoice.taxNumber) {
      this.$message.warning("请输入税号");
      return;
    }
    if (!this.invoice.email) {
      this.$message.warning("请输入邮箱");
      return;
    }
    if (
      !/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
        this.invoice.email
      )
    ) {
      this.$message.warning("邮箱格式不正确");
      return;
    }

    this.loading = true;
    api
      .post("J27737", {
        ...this.invoice,
        orderId: this.id,
        userId: this.userId,
      })
      .then((res) => {
        this.$message.success("操作成功");
        this.InvoiceDialog = false;
        this.fetchData();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  clickButton(buttonMark: any) {
    this.file = [];
    if (buttonMark == "invoice") {
      // 发票申请
      this.invoice = {
        bankAccount: "",
        bankName: "",
        companyAddress: "",
        companyPhone: "",
        email: "",
        invoiceTitle: "",
        orderId: "",
        taxNumber: "",
        invoiceType: "",
        userId: "",
      };
      this.InvoiceDialog = true;
    } else if (buttonMark == "contact") {
      //  联系客户
      this.toKeHu();
    } else if (buttonMark == "downInvoice") {
      api.post("J27770", { id: this.id }).then((res) => {
        base64DownloadFile(res.fileName, res.fileBase64 )
      });
    } else if (buttonMark == "refund") {
      this.refundForm = {};
      this.refundFile = {};
      this.refundDialog = true;
    } else if (buttonMark == "cancle") {
      this.cancleForm = {};
      this.cancleFile = [];
      this.cancleDialog = true;
    }
  }

  fetchData() {
    let { id, orderNo } = this.$route.query;
    api.post("J27753", { id: id,orderNo: orderNo }).then((res) => {
      this.id = res.id;
      this.order = res;
      this.getPayList();
    });
  }

  getConfig() {
    api.getJavaConfig().then((res) => {
      this.config = res;
    });
  }


  activated() {
    let { id, orderNo } = this.$route.query;
    this.activeName = 'zhifu'
    this.fetchData();
    this.getConfig();
  }
}
